import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import DataObject from './index.js';
var ColorScale = /*#__PURE__*/function (_DataObject) {
  function ColorScale() {
    var _this;
    _classCallCheck(this, ColorScale);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ColorScale, [].concat(args));
    _defineProperty(_this, "colors", ['#f55d6e',
    // Not achieved
    '#1bd308',
    // Lowest
    '#1ede34', '#23de96', '#12d3ad', '#2bbbc1',
    // Middle
    '#179bbc', '#1e87b5', '#1e6fb5', '#0b5ca8' // Highest
    ]);
    return _this;
  }
  _inherits(ColorScale, _DataObject);
  return _createClass(ColorScale, [{
    key: "get",
    value: function get() {
      var addRed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var size = this.data;
      if (addRed) {
        size = size - 1;
      }
      var result = [];
      if (size == 1) {
        result = [this.colors[1]];
      }
      if (size == 2) {
        result = [this.colors[1], this.colors[9]];
      }
      if (size == 3) {
        result = [this.colors[1], this.colors[5], this.colors[9]];
      }
      if (size == 4) {
        result = [this.colors[1], this.colors[5], this.colors[7], this.colors[9]];
      }
      if (size == 5) {
        result = [this.colors[1], this.colors[3], this.colors[5], this.colors[7], this.colors[9]];
      }
      if (size == 6) {
        result = [this.colors[1], this.colors[3], this.colors[5], this.colors[6], this.colors[8], this.colors[9]];
      }
      if (size == 7) {
        result = [this.colors[1], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[8], this.colors[9]];
      }
      if (size == 8) {
        result = [this.colors[1], this.colors[2], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[8], this.colors[9]];
      }
      if (size == 9) {
        result = [this.colors[1], this.colors[2], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[7], this.colors[8], this.colors[9]];
      }
      if (size > 9) {
        result = [this.colors[1], this.colors[2], this.colors[3], this.colors[4], this.colors[5], this.colors[6], this.colors[7], this.colors[8], this.colors[9]];
        var needed = size - 9;
        for (var i = 0; i < needed; i++) {
          result.push(this.colors[9]);
        }
      }
      if (addRed) {
        result.unshift(this.colors[0]);
      }
      return result;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.colors;
    }
  }]);
}(DataObject);
export default ColorScale;